.divider {
  margin: 16px;
}
